import { Component, inject } from '@angular/core';
import { table, CacTableComponent, SortModel } from '@controladad/ng-base';
import { KwdCurrencyPipe } from '@core';

import {
  WalletTransactionApiService,
  cacTableIdRangeCol,
  cacTableAmountRangeCol,
  cacTableDateRangeCol
} from '@core';

@Component({
  selector: 'lib-wallet-transactions',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './wallet-transactions.component.html',
  styleUrls: ['./wallet-transactions.component.scss'],
})
export class WalletTransactionsComponent {
  private readonly walletTransactionApi = inject(WalletTransactionApiService);
  private kwdPipe = new KwdCurrencyPipe();

  table = table({
    itemsFn: this.walletTransactionApi.getAdapter({
      mapFn: (response) => {
        console.log('API Response:', response); // Debug log
        return response;
      }
    }),
    sortModel: new SortModel('transactionDate', 'desc'),
    export: (options) => this.walletTransactionApi.exportToExcel(options),
    view: {
      itemName: 'Wallet Transaction',
      title: 'Wallet Transactions',
    },
    columns: {
      id: {
        ...cacTableIdRangeCol(),
        filterable: [
          { type: 'greater', key: 'IdFrom', inputType: 'number', label: 'From' },
          { type: 'lower', key: 'IdTo', inputType: 'number', label: 'To' },
        ],
      },
      transactionDate: {
        ...cacTableDateRangeCol('Transaction Date', 'transactionDate'),
        filterable: [
          { type: 'greater', key: 'TransactionDateFrom', controlType: 'date', label: 'From' },
          { type: 'lower', key: 'TransactionDateTo', controlType: 'date', label: 'To' },
        ],
        type: 'date',
      },
      isAdminTransaction: {
        label: 'By Admin or Customer',
        sortable: true,
        filterable: [
          {
            type: 'equal',
            key: 'IsAdminTransaction',
            controlType: 'select',
            items: [
              { value: true, label: 'Admin' },
              { value: false, label: 'Customer' },
            ],
          },
        ],
        transform: (value) => value ? 'Admin' : 'Customer',
      },
      type: {
        label: 'Type',
        sortable: true,
        filterable: [
          {
            type: 'equal',
            key: 'Type',
            controlType: 'select',
            items: [
              { value: 0, label: 'Withdraw' },
              { value: 1, label: 'Deposit' },
            ],
            multiple: true,
          },
        ],
        transform: (value) => {
          console.log('Type value:', value, typeof value); // Debug log
          const numValue = Number(value);
          return numValue === 1 ? 'Deposit' : 'Withdraw';
        },
      },
      amount: {
        ...cacTableAmountRangeCol(),
        filterable: [
          { type: 'greater', key: 'AmountFrom', inputType: 'number', label: 'From' },
          { type: 'lower', key: 'AmountTo', inputType: 'number', label: 'To' },
        ],
        transform: (value, row) => {
          if (!value && value !== 0) return '';
          const isDeposit = row.type === 1;
          const sign = isDeposit ? '+' : '-';
          return `${sign}${this.kwdPipe.transform(Math.abs(Number(value)))}`;
        },
      },
      customerFullName: {
        label: 'Customer Full Name',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'CustomerFullName',
          },
        ],
      },
      comment: {
        label: 'Comment',
        sortable: true,
        class: 'multiline-text',
      },
      paymentMethod: {
        label: 'Payment Method',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'PaymentMethod',
          },
        ],
        transform: (value) => {
          // PaymentMethod is now a string, so return it directly
          return value || '';
        },
      },
      transactionId: {
        label: 'Transaction Id',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'TransactionId',
          },
        ],
        transform: (value) => value || '',
      },
      orderId: {
        label: 'Order Id',
        sortable: true,
        filterable: [
          {
            type: 'contains',
            key: 'OrderId',
          },
        ],
        transform: (value) => value || '',
      },
    },
  });
}
